import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=59a55a22&scoped=true"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a55a22",
  null
  
)

export default component.exports